<img src="assets/images/static/menu-cross.svg" />
